module.exports = __webpack_public_path__ + "static/media/LongArrowRight.f09c490d.svg";